// extracted by mini-css-extract-plugin
module.exports = {"listitem":"PlayersList_listitem__3Rsey","playertag":"PlayersList_playertag__2nR1_"};